// MCP Tool Names - defines all available MCP tools in the system

// alphabetically sorted
export enum MCPToolName {
  AcceptVaveMTA = "acceptVaveMTA",
  AddCrmAgencyNote = "addCrmAgencyNote",
  AddCrmComplianceDocument = "addCrmComplianceDocument",
  AddMarketingPlanSubmissions = "addMarketingPlanSubmissions",
  AddOpportunityNote = "addOpportunityNote",
  AddRedactedBinderToPolicy = "addRedactedBinderToPolicy",
  AddRedactedQuote = "addRedactedQuote",
  ApplyMarketingPlanTemplateToOpportunity = "applyMarketingPlanTemplateToOpportunity",
  AssociateFile = "associateFile",
  AttachCoverLetterToQuote = "attachCoverLetterToQuote",
  AttachEmailToClickUpTask = "attachEmailToClickUpTask",
  BindQuoteToBindHq = "bindQuoteToBindHq",
  BrowserbaseUploadFile = "browserbaseUploadFile",
  CommentOnClickUpTask = "commentOnClickUpTask",
  CompleteMarketingPlans = "completeMarketingPlans",
  ComputeBrokerFee = "computeBrokerFee",
  ConvertDocxToPdf = "convertDocxToPdf",
  CreateCarrier = "createCarrier",
  CreateCrmComplianceUploadUrl = "createCrmComplianceUploadUrl",
  CreateClickUpTask = "createClickUpTask",
  CreateEmailDraft = "createEmailDraft",
  CreateSubmissionEmailDraft = "createSubmissionEmailDraft",
  CreateForwardEmailDraft = "createForwardEmailDraft",
  CreateInsured = "createInsured",
  CreateMarketingPlanTemplateFromOpportunity = "createMarketingPlanTemplateFromOpportunity",
  CreateOpportunity = "createOpportunity",
  CreatePlaybookFromConversation = "createPlaybookFromConversation",
  CreateProcessedBinder = "createProcessedBinder",
  CreateQuoteFromFileUpload = "createQuoteFromFileUpload",
  CreateReplyEmailDraft = "createReplyEmailDraft",
  CreateSubmission = "createSubmission",
  CreateVaveQuote = "createVaveQuote",
  CreateVaveRenewalQuote = "createVaveRenewalQuote",
  CrmBrokerLookup = "crmBrokerLookup",
  DownloadFile = "downloadFile",
  DraftToCarrier = "draftToCarrier",
  EditOpportunity = "editOpportunity",
  EditPolicy = "editPolicy",
  EditQuote = "editQuote",
  Elicit = "elicit",
  EmailCarrier = "emailCarrier",
  ExecutePlaybook = "executePlaybook",
  ExportLossRunData = "exportLossRunData",
  /** @deprecated Use GetAppetiteProducts instead which provides historical data-backed market fit analysis with green/yellow/red classification */
  FindCarrierAppetite = "findCarrierAppetite",
  FindCarriers = "findCarriers",
  FindClickUpTaskByConversation = "findClickUpTaskByConversation",
  FindOrCreateAgent = "findOrCreateAgent",
  FindRelevantFiles = "findRelevantFiles",
  FindStaleMarketingPlans = "findStaleMarketingPlans",
  FillTemplate = "fillTemplate",
  GenerateAmriscSOV = "generateAmriscSOV",
  GenerateFallowGroveSOV = "generateFallowGroveSOV",
  GenerateJupiterSOV = "generateJupiterSOV",
  GeneratePdfFromHtml = "generatePdfFromHtml",
  GenerateQuoteCoverLetter = "generateQuoteCoverLetter",
  GenerateSurplusLinesForm = "generateSurplusLinesForm",
  GetAccountLifecycle = "getAccountLifecycle",
  GetAgencyByDomain = "getAgencyByDomain",
  GetAgentProfile = "getAgentProfile",
  GetAppetiteProducts = "getAppetiteProducts",
  GetAppetiteProductText = "getAppetiteProductText",
  GetBindHqAgencies = "getBindHqAgencies",
  GetBindHqAgents = "getBindHqAgents",
  GetBindHqCarriers = "getBindHqCarriers",
  GetBindHqInsureds = "getBindHqInsureds",
  GetBindHqMarketingCompanies = "getBindHqMarketingCompanies",
  GetBookOverview = "getBookOverview",
  GetBrokerAssignments = "getBrokerAssignments",
  GetBrokers = "getBrokers",
  GetBuildingInformation = "getBuildingInformation",
  GetCarrierContacts = "getCarrierContacts",
  GetClickUpListFields = "getClickUpListFields",
  GetConversationById = "getConversationById",
  GetConversationsByInsured = "getConversationsByInsured",
  GetCrmAgencyProfile = "getCrmAgencyProfile",
  GetCurrentTime = "getCurrentTime",
  GetInsured = "getInsured",
  GetInsuredFiles = "getInsuredFiles",
  GetLineOfBusiness = "getLineOfBusiness",
  GetMessageById = "getMessageById",
  GetMessagesByConversation = "getMessagesByConversation",
  GetMuellerOrder = "getMuellerOrder",
  GetMuellerOrders = "getMuellerOrders",
  GetMuellerPrograms = "getMuellerPrograms",
  GetOpportunities = "getOpportunities",
  GetOpportunityContacts = "getOpportunityContacts",
  GetOpportunityContext = "getOpportunityContext",
  GetPolicies = "getPolicies",
  GetPolicyById = "getPolicyById",
  GetPreferredCaseUpdate = "getPreferredCaseUpdate",
  GetPreferredCases = "getPreferredCases",
  GetQuoteById = "getQuoteById",
  GetQuotesBySubmission = "getQuotesBySubmission",
  GetSecondaryContacts = "getSecondaryContacts",
  GetStaleAccounts = "getStaleAccounts",
  GetSubmissions = "getSubmissions",
  GetUserAccountByEmail = "getUserAccountByEmail",
  KnowledgeAgentInfo = "knowledgeAgentInfo",
  KnowledgeCarrierInfo = "knowledgeCarrierInfo",
  KnowledgeChat = "knowledgeChat",
  KnowledgeSearch = "knowledgeSearch",
  KnowledgeSimilarDeals = "knowledgeSimilarDeals",
  LinkConversationToInsured = "linkConversationToInsured",
  LinkConversationToOpportunity = "linkConversationToOpportunity",
  LinkConversationToSubmission = "linkConversationToSubmission",
  LinkRenewalOpportunity = "linkRenewalOpportunity",
  ListMyBook = "listMyBook",
  ManuallyAssignBrokerToOpportunity = "manuallyAssignBrokerToOpportunity",
  MarkPreferredCasesExported = "markPreferredCasesExported",
  NotifyAccounting = "notifyAccounting",
  NotifyAgent = "notifyAgent",
  NotifyBroker = "notifyBroker",
  NotifyService = "notifyService",
  PatchJsonDocument = "patchJsonDocument",
  PlaybookDiscovery = "playbookDiscovery",
  PlaybookReader = "playbookReader",
  PredictPremiumsForInsured = "predictPremiumsForInsured",
  PriceAdjustmentVaveQuote = "priceAdjustmentVaveQuote",
  PriceCancellationVaveQuote = "priceCancellationVaveQuote",
  QueryJsonDocument = "queryJsonDocument",
  RedactDocument = "redactDocument",
  RequestFollowUp = "requestFollowUp",
  ResolveVaveAppetiteProduct = "resolveVaveAppetiteProduct",
  RelinkBindHqPolicy = "relinkBindHqPolicy",
  SearchClickUpTasks = "searchClickUpTasks",
  SearchConversationAttachmentsForInformation = "searchConversationAttachmentsForInformation",
  SearchFileForInformation = "searchFileForInformation",
  SearchFilesForInformation = "searchFilesForInformation",
  SearchInsuredFilesForInformation = "searchInsuredFilesForInformation",
  SearchMarketingPlanTemplates = "searchMarketingPlanTemplates",
  SearchPolicies = "searchPolicies",
  SendRenewalEmail = "sendRenewalEmail",
  SendSlackMessage = "sendSlackMessage",
  SubmitToCarrier = "submitToCarrier",
  TransitionOpportunity = "transitionOpportunity",
  TransitionPolicy = "transitionPolicy",
  TransitionQuote = "transitionQuote",
  TransitionSubmission = "transitionSubmission",
  UniversalSearch = "universalSearch",
  UnlinkConversationFromInsured = "unlinkConversationFromInsured",
  UnlinkConversationFromOpportunity = "unlinkConversationFromOpportunity",
  UnlinkConversationFromSubmission = "unlinkConversationFromSubmission",
  UpdateClickUpTask = "updateClickUpTask",
  UpdateCrmAgencyProfile = "updateCrmAgencyProfile",
  UpdateInsuredAddresses = "updateInsuredAddresses",
  UploadFileToInsured = "uploadFileToInsured",
  WorkbookTool = "workbookTool",
}

/**
 * Headings these playbook authors put above a tool *manifest* — an inventory of tools the
 * playbook holds, declines, or deliberately leaves unchecked. Manifest entries read like call
 * signatures (`transitionPolicy (hard dock records subjectivity satisfaction — it does not move
 * policy state)`), so everything from the first heading line onward is not steps and is not
 * searched.
 */
const TOOL_MANIFEST_HEADING =
  /(^|\n)[ \t]*(?:TOOL MANIFEST|NOT LINKED|Leave UNCHECKED)(?:[ \t]*:|[ \t]*[—-].*)?[ \t]*(?=\n|$)/;

/**
 * `toolName(` for every tool, longest name first so a shorter name can never win a position a
 * longer one also matches. Tool names are bare identifiers, so none of them need escaping.
 */
const TOOL_CALL_SIGNATURE = new RegExp(
  String.raw`\b(${Object.values(MCPToolName)
    .sort((a, b) => b.length - a.length)
    .join("|")})\s*\(`,
  "g"
);

/**
 * Tool names a workflow's steps *call*, read off call signatures in its prose.
 *
 * Playbooks name tools for three reasons and only one of them is a call: they call them
 * (`getOpportunityContext(opportunityId)`), they forbid them (`Do not call createInsured,
 * createOpportunity`), and they inventory them in a manifest. Requiring an open paren rules out
 * the prohibitions; truncating at the manifest heading rules out the inventory.
 *
 * Precision is the constraint, not recall — a warning authors learn to dismiss is how the existing
 * colour hint already failed. Bare mention matching flags 26 playbooks and 95 tools at roughly 17%
 * real, six of them on `Orbit · Ingress`, whose author documents every excluded tool in prose.
 * This pair flags nothing across the 73 playbooks holding a real filter on 2026-09-10, and on
 * `Orbit 5 · Transmit`'s pre-repair whitelist it names the three transitions that never fired
 * across 85 runs. Flagging materially more than a couple of playbooks corpus-wide is a regression,
 * not better coverage.
 *
 * Takes plain text rather than markup, and lives beside the enum it is built from, so a caller
 * that parses HTML differently cannot fork the detector — a forked copy of the chip selector is
 * why the existing repair path never saw these playbooks.
 */
export function findCalledToolNamesInSteps(workflowText: string): MCPToolName[] {
  const manifest = TOOL_MANIFEST_HEADING.exec(workflowText);
  const steps = manifest ? workflowText.slice(0, manifest.index) : workflowText;

  const called = new Set<MCPToolName>();
  // Group 1 can only be one of the enum values the alternation was built from.
  for (const [, toolName] of steps.matchAll(TOOL_CALL_SIGNATURE)) {
    called.add(toolName as MCPToolName);
  }

  return [...called];
}

/**
 * Provenance for MCP `resource_link` items.
 *
 * Optional on the wire: a missing `_meta.origin` means {@link MCP_RESOURCE_ORIGIN.Discovered}.
 * Only generating tools opt in with `"generated"`; the ~25 existing emitters stay untouched.
 */
export const MCP_RESOURCE_ORIGIN = {
  Discovered: "discovered",
  Generated: "generated",
} as const;

export type McpResourceOrigin = (typeof MCP_RESOURCE_ORIGIN)[keyof typeof MCP_RESOURCE_ORIGIN];

/**
 * `_meta` on `qw.draft.*` links.
 * Producer: `base-create-email-draft`. Consumer: `@qw/chat`.
 *
 * `origin` is required on this producer type. Consumers treating unknown resource links
 * must still treat a missing `origin` as discovered.
 *
 * `classification` is `string` deliberately: the tool input accepts `"info-request"` and the
 * column is an unconstrained `String?`, but `DraftContext["classification"]` omits that value.
 */
export interface DraftResourceLinkMeta {
  origin: typeof MCP_RESOURCE_ORIGIN.Generated;
  draftId: string;
  from: string;
  subject?: string;
  to: string[];
  cc: string[];
  bcc: string[];
  scheduledSendAt?: string;
  insuredId?: string;
  opportunityId?: string;
  submissionId?: string;
  classification?: string;
}

const readStringArray = (value: unknown): string[] | undefined => {
  if (!Array.isArray(value) || value.some((item) => typeof item !== "string")) {
    return undefined;
  }
  return value;
};

const pickOptionalString = <K extends string>(key: K, value: unknown): Partial<Record<K, string>> =>
  typeof value === "string" ? ({ [key]: value } as Partial<Record<K, string>>) : {};

/**
 * Parse a generated `qw.draft.*` `_meta` payload. Missing `origin` is discovered, not generated.
 */
export const parseDraftResourceLinkMeta = (meta: unknown): DraftResourceLinkMeta | undefined => {
  if (meta === null || typeof meta !== "object") {
    return undefined;
  }

  const record = meta as Record<string, unknown>;
  if (record.origin !== MCP_RESOURCE_ORIGIN.Generated) {
    return undefined;
  }
  if (typeof record.draftId !== "string" || typeof record.from !== "string") {
    return undefined;
  }

  const to = readStringArray(record.to);
  const cc = readStringArray(record.cc);
  const bcc = readStringArray(record.bcc);
  if (!to || !cc || !bcc) {
    return undefined;
  }

  return {
    origin: MCP_RESOURCE_ORIGIN.Generated,
    draftId: record.draftId,
    from: record.from,
    to,
    cc,
    bcc,
    ...pickOptionalString("subject", record.subject),
    ...pickOptionalString("scheduledSendAt", record.scheduledSendAt),
    ...pickOptionalString("insuredId", record.insuredId),
    ...pickOptionalString("opportunityId", record.opportunityId),
    ...pickOptionalString("submissionId", record.submissionId),
    ...pickOptionalString("classification", record.classification),
  };
};

export const isGeneratedDraftResourceLink = (resource: { uri?: string; _meta?: unknown }): boolean =>
  typeof resource.uri === "string" &&
  resource.uri.startsWith("qw.draft.") &&
  parseDraftResourceLinkMeta(resource._meta) !== undefined;

/** Isolate the `DraftResourceLinkMeta` → MCP `_meta` Record boundary in one place. */
export const toMcpResourceLinkMeta = (meta: DraftResourceLinkMeta): Record<string, unknown> =>
  Object.fromEntries(Object.entries(meta).filter(([, value]) => value !== undefined));

export enum MCPPlatform {
  /**
   * Public MCP server intended for desktop clients (Cursor, Claude Desktop, etc).
   *
   * IMPORTANT: Tools should be explicitly opted-in to this platform.
   */
  EXTERNAL = "external",
  INBOX = "inbox",
  WEB = "web",
}
